import { API_BASE_URL, ADMIN_SECRET } from '../utils/constants';

const API_BASE = `${API_BASE_URL}/api/products`;

export const fetchProducts = async (page = 1, limit = 20) => {
  const res = await fetch(`${API_BASE}?page=${page}&limit=${limit}`);
  if (!res.ok) throw new Error('Failed to fetch products');
  return res.json();
};

export const fetchAllProducts = async () => {
  const res = await fetch(`${API_BASE}/all`);
  if (!res.ok) throw new Error('Failed to fetch products');
  return res.json();
};

export const createProduct = async (product) => {
  const res = await fetch(API_BASE, {
    method: 'POST',
    headers: { 'admin-secret': `${ADMIN_SECRET}` },
    body: product,
  });
  if (!res.ok) throw new Error('Failed to create product');
  return res.json();
};

export const updateProduct = async (id, product) => {
  const res = await fetch(`${API_BASE}/${id}`, {
    method: 'PUT',
    headers: { 'admin-secret': `${ADMIN_SECRET}` },
    body: product,
  });
  if (!res.ok) throw new Error('Failed to update product');
  return res.json();
};

export const deleteProduct = async (id) => {
  const res = await fetch(`${API_BASE}/${id}`, {
    method: 'DELETE',
    headers: {
      'admin-secret': `${ADMIN_SECRET}`, // ✅ required
    },
  });
  if (!res.ok) throw new Error('Failed to delete product');
  return res.json();
};

export const fetchProductById = async (id) => {
  const res = await fetch(`${API_BASE_URL}/api/products/${id}`);
  if (!res.ok) throw new Error('Failed to fetch product');
  return res.json();
};

export const fetchSponsoredProducts = async () => {
  const res = await fetch(`${API_BASE_URL}/api/products/sponsored`);
  if (!res.ok) throw new Error('Failed to load sponsored products');
  return res.json();
};